import {TranslationsManager} from "../utils/localisationManager";

export function doStyleNavigation() {
    $('#navigation').insertAfter('.header-top > div:first-child')

    $(`<a class="btn btn-icon search-icon full hovered" href="${TranslationsManager.doGetLINKByLang("SEARCH")}">
                <span class="sr-only">Nákupní košík</span>`).prependTo('.navigation-buttons');

    if($(window).width() < 768) {
        doStyleBurgerMenu();
    }

    doStyleTopNavigationMenuBar();
    doStyleSearch();
    doStyleChangeDomain();
}

function doStyleTopNavigationMenuBar() {
    $(`
        <a href="${TranslationsManager.doGetLINKByLang('INSTAGRAM')}" class="top-nav-button top-nav-button-instagram" target="_blank"></a>
        <a href="${TranslationsManager.doGetLINKByLang('FACEBOOK')}" class="top-nav-button top-nav-button-facebook" target="_blank"></a>
    `).prependTo('.top-navigation-bar .top-navigation-tools');
}

function doStyleChangeDomain() {
    $(`
        <div class="language-box">
            <div class="button">
                <img src="https://cdn.myshoptet.com/usr/api.fv-studio.cz/user/documents/upload/clients/utopy.cz/img/icons/flags/${TranslationsManager.doGetStringByLang('FLAG_DOMAIN')}.svg" alt="utopy-${TranslationsManager.doGetStringByLang('FLAG_DOMAIN')}">
            </div>
            <div class="dropdown">
                <a href="https://www.utopy.cz/"><img src="https://cdn.myshoptet.com/usr/api.fv-studio.cz/user/documents/upload/clients/utopy.cz/img/icons/flags/cs.svg" alt="cz">Česky (CZK)</a>
                <a href="https://www.utopy.sk/"><img src="https://cdn.myshoptet.com/usr/api.fv-studio.cz/user/documents/upload/clients/utopy.cz/img/icons/flags/sk.svg" alt="sk">Slovensky (EUR)</a>
<!--                <a href="https://www.utopy.ro/"><img src="https://cdn.myshoptet.com/usr/api.fv-studio.cz/user/documents/upload/clients/utopy.cz/img/icons/flags/ro.svg" alt="ro">Româna (RON)</a>-->
<!--                <a href="https://www.utopy.hu/"><img src="https://cdn.myshoptet.com/usr/api.fv-studio.cz/user/documents/upload/clients/utopy.cz/img/icons/flags/hu.svg" alt="hu">Magyar (HUF)</a>-->
                <a href="https://www.utopy.eu/"><img src="https://cdn.myshoptet.com/usr/api.fv-studio.cz/user/documents/upload/clients/utopy.cz/img/icons/flags/eu.svg" alt="en">English (EUR)</a>
            </div>
        </div>
    `).appendTo('.top-navigation-tools');

    const $languageBox = $('.language-box');
    $languageBox.click(function () {
        $languageBox.toggleClass('active');
    })
}

function doStyleSearch() {
    const $search = $('#header .header-top .search');
    $search.insertBefore('#header .cart-count');
    $search.hover(function () {
        $search.toggleClass('hovered');
    })
}

function doStyleBurgerMenu() {
    $('#navigation .navigation-in ul.menu-level-2 > li a.menu-image img').each(function (index, element) {
        const dataSrc = $(element).attr('data-src');
        $(element).attr('src', dataSrc);
    })
}
